import React from 'react';
import { inject, observer } from "mobx-react";
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import Budget from './ManageCampaign/Options/Budget'

import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {
      flexGrow: 1,
    },
    margin: {

    },
    withoutLabel: {
      marginTop: theme.spacing.unit * 3,
    },
    textField: {
      flexBasis: 200,
    },
    card: {
      width: '100%',
    },
    title: {
      marginBottom: 16,
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
    description:{
      color:'#DFC10F',
      fontWeight: 'bold'
    },
  });
  



@inject("commonStore")
@inject("authStore")
@observer
class CampaignBalanceDialog extends React.Component {

    state = {
        newBalance: 0,
        isDisabled: true
    };
    componentDidMount(){
     
        const { campaign } = this.props;
        const { balance } = campaign
        this.setState({newBalance: balance})
    }
    
    handleChange = event => {
        console.log(event.target.value)

        const value = event.target.value

        this.handleBalanceUpdate(value)
/*
        const { campaign, commonStore } = this.props
        const { balance } = campaign
        const { credit } = commonStore.agent

        const value = event.target.value

        if(value === 0 || value === '' || value === undefined || value === null){
          this.setState({newBalance: 0})
          return
        }
    
        const newBalance = value * 100
        //const newBalance = balance - amount
    
        if(parseInt(newBalance)){
            let isValid = true
            if (newBalance > credit){
              let isValid = false
            }
            console.log(newBalance)
            this.setState({newBalance})
        }*/
      };
      
  handleBalanceUpdate = value => {

    const { campaign, commonStore } = this.props
    const { balance } = campaign
    const { credit } = commonStore.agent
    let isDisabled = false
    
    if(value === 0 || value === '' || value === undefined || value === null){
      this.setState({newBalance: 0})
      return
    }

    const newBalance = parseInt(value) * 100
    const amount = newBalance - balance

      if(amount > credit){
        isDisabled = true
      }
        
      console.log(newBalance)
      this.setState({newBalance, isDisabled})


  }
  makeQuickButtons = () => {
        const { handleUpdate, commonStore } = this.props

        const { credit } = commonStore.agent
        let dollars = 100
        const arrayOfButtons = []
          for (let i = 0; i < 10; i++) { 
            if (dollars < (credit / 100) + 1){
              const amount = dollars * 1
            arrayOfButtons.push(
            
                <Button key={dollars} onClick={() => {this.handleBalanceUpdate(amount)}}> {`$${dollars}`} </Button>
            )
          }
          dollars = dollars + 100
        }
        return arrayOfButtons
}

  makeBudgetField = () => {
        const { newBalance } = this.state
        const { classes, commonStore, campaign } = this.props;
        const { credit } = commonStore.agent
        const { campaignID, balance, priceMapType } = campaign

        const quickButtons = this.makeQuickButtons()
        
        return (
          <div className={classes.root}>
          {quickButtons.length > 0 ? <Typography className={classes.title} color="textSecondary"> Quick Select Amount  {quickButtons} </Typography> : null }
   
            <Typography className={classes.title} color="textSecondary">
             {`Your current campaign balance is $${balance / 100}.00`}
            </Typography>

            {!priceMapType ? 
              <Typography className={classes.title} color="textSecondary">
              {`This campaign cannot increase its balance due to price changes. You can decrease your balance at anytime.`}
              </Typography>
              : null
            }

            {priceMapType || (!priceMapType &&  balance > 0) ? 
        
            <FormControl fullWidth className={classes.margin}>
              <InputLabel htmlFor="adornment-amount">New Campaign Balance:</InputLabel>
              <Input
                id="adornment-amount"
                value={newBalance === 0 ? 0 : newBalance / 100}
                onChange={this.handleChange}
                startAdornment={<InputAdornment position="start">$</InputAdornment>}
              />
              <Typography className={classes.title} color="textSecondary">
              {`New adjusted campaign balance will be $${(newBalance) / 100  }.00`}
              </Typography>
              <Typography className={classes.title} color="textSecondary">
              {`After this update your available account credit will be $${((credit + (balance - newBalance)) / 100).toFixed(2)}`}
              </Typography>
            </FormControl> :

                <Typography className={classes.title} color="textSecondary">
                {`Please create a new campaign. This campaign cannot increase its balance due to price changes`}
                </Typography>
              
            }


          </div>
        );
  
  }

  render() {
      const { newBalance, isDisabled } = this.state
      const { classes, commonStore, campaign, open, close, redirect, update, loading } = this.props
      const { agent, network } = commonStore
      const { credit } = agent
      const { campaignID, balance, campaignName, fixedCampaignName } = campaign

      console.log('fixedCampaignName')
      console.log(fixedCampaignName)
      console.log(network)

      let fixedMessage = ''
      if(fixedCampaignName){
        const { priceMaps: { fixed }} = network

        if(fixedCampaignName in fixed){
          const { price, notification } = fixed[fixedCampaignName]
          if(notification){
            fixedMessage = notification
          }else{
            fixedMessage = `Current Special Offer Price $${price/100}`
          }

        }
      }




    return (
  
        <Dialog
          open={open}
        //  onClose={close}
          aria-labelledby="form-dialog-title"
        >
       
        <DialogActions>
        <Button disabled={loading} onClick={() => update({campaignID, campaignStatus: 'deleted', amount: balance * -1})} color="primary">
        Delete Campaign
        </Button>
        <Button onClick={redirect} color="primary">
            Edit Campaign
         </Button>
      </DialogActions>
          <DialogTitle id="form-dialog-title">Balance Update </DialogTitle>
          <DialogContent>
            <div className={classes.description}>
              <Typography color={'inherit'}>{fixedMessage}</Typography>
            </div>
           {this.makeBudgetField()}
           {loading ? <LinearProgress /> : null }
          </DialogContent>
          <DialogActions>
            <Button disabled={loading} onClick={close} color="primary">
              Cancel
            </Button>
            <Button disabled={loading || isDisabled} onClick={() => update({campaignID, campaignStatus: 'active', amount: newBalance - balance})} color="primary">
              Update Balance
            </Button>
       
          </DialogActions>
          
        </Dialog>

    );
  }
}

CampaignBalanceDialog.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
export default withStyles(styles)(CampaignBalanceDialog);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/CampaignBalanceDialog.js